import type { Feature } from '@/shared/registry'

/**
 * Not Found's page and messages. Site Management's web pages own the catch-all route (SM-26): it
 * tries an unknown address as a vanity URL, then shows this page, behind the sign-in guard for
 * anyone signed out, so an unknown address is never a way past the guard.
 */
export const feature: Feature = {
  id: 'not-found',
}
